import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingSeedanceAiVideoGeneratorConfig } from '@/data/landingConfig/landingSeedanceAiVideoGeneratorConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_SeedanceAiVideoGenerator } from './schemaObject';

interface Props {}
const SeedanceAiVideoGenerator: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_SeedanceAiVideoGenerator} />
			<LandingTemplate
				data={landingSeedanceAiVideoGeneratorConfig}
				funnelLinkService={GenerateLandingLinkService.funnelTextToVideoV2()}
			/>
		</>
	);
};

export default SeedanceAiVideoGenerator;
